import React from 'react'
import {Col, Row} from "antd";
import {useTranslations} from "../../lang";

export default function CropTiming({crop}) {

    const {translate} = useTranslations()

    const monthLables = [
        '-',
        translate('Jan'),
        translate('Feb'),
        translate('Mrt'),
        translate('Apr'),
        translate('Mei'),
        translate('Jun'),
        translate('Jul'),
        translate('Aug'),
        translate('Sep'),
        translate('Oct'),
        translate('Nov'),
        translate('Dec')
    ]

    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    const inPeriod = (month, min, max) => {
        if (min > max) {
            return month >= min || month <= max
        }
        return month >= min && month <= max
    }

    if(!crop) {
        return null;
    }

    return (
        <>
        {crop.timing_warning && (
            <div role="alert" className="alert alert-warning mb-2">
                {crop.timing_warning}
            </div>
        )}
        <Row gutter={[1,1]}>
            {months.map(month => {
                return (
                    <Col key={month} md={2} xs={0} className={"text-center"} style={{border: 'solid 1px #efefef', lineHeight:'24px'}}>
                        <span>{monthLables[month]}</span>
                        <div style={{display:'flex', width: '100%', height: '24px'}}>
                        {(inPeriod(month, crop.sow_min, crop.sow_max)) && (
                            <div className={"block period-in-seed"}></div>
                        )}

                        {(inPeriod(month, crop.plant_min, crop.plant_max)) && (
                            <div className={"block period-in-bed"}></div>
                        )}
                        {(inPeriod(month, crop.harvest_min, crop.harvest_max)) && (
                            <div className={"block period-in-harvest"}></div>
                        )}
                        </div>
                    </Col>
                )
            })}
            <Col md={0} xs={24}>
                {crop.is_direct_sown === true && (
                    <>Direct zaaien: {monthLables[crop.sow_min]} - {monthLables[crop.sow_max]} <br/></>
                )}
                {(!crop.is_direct_sown && !crop.is_seedling) && (
                    <>Zaaien: {monthLables[crop.sow_min]} - {monthLables[crop.sow_max]} <br/></>
                )}
                {crop.is_direct_sown !== true && (
                    <>Planten: {monthLables[crop.plant_min]} - {monthLables[crop.plant_max]} <br/></>
                )}
                Oogsten: {monthLables[crop.harvest_min]} - {monthLables[crop.harvest_max]} <br/>
                <br/>
            </Col>
        </Row>
        </>
    )
}